import { z } from 'zod';

export const TenantSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  slug: z.string(),
  domains: z.array(z.string()),
  rowStatus: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type Tenant = z.infer<typeof TenantSchema>;

export const CreateTenantInput = z.object({
  name: z.string().min(1).max(200),
  slug: z
    .string()
    .min(1)
    .max(64)
    .regex(/^[a-z0-9-]+$/, 'lowercase letters, numbers, hyphens only'),
  domains: z.array(z.string().min(3)).min(1),
});
export type CreateTenantInput = z.infer<typeof CreateTenantInput>;

export const UpdateTenantInput = CreateTenantInput.partial();
export type UpdateTenantInput = z.infer<typeof UpdateTenantInput>;
